<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->
            <!--header-->
            <div class="row row-replace add-m-b">
                <!-- header  -->
                <div class="col-md-6 col-9 col-p h5"><i class="fa fa-medkit"></i> Seat Availability Pune Floor</div>
                <div class="col-md-6 col-3 top-corner-items col-p">
                    <button class="btn btn-primary btn-sm"  routerLink="/dashboard"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>
            <!--end header-->
           

             <div class="row row-replace m-t-30">
                 <div class="col-12">
                     <div style="background-image:url('./assets/img/back/pune.jpg');width:600px;height:700px;border:1px solid black;margin:0 auto;" class="zoom">
                    
                        <button class="btn btn-sm btn-success setPo" *ngFor="let x of numb" [ngStyle]="{'margin':x.xy}">{{x.n}}</button>

                    </div>
                 </div>
             </div>

             
      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           

